// Non-component exports separated for Vite Fast Refresh compatibility
export const defaultSettings = {
  logo: '/logo_br.svg',
  navTheme: 'light',
  layout: 'topmenu',
  fixedHeader: true,
  contentWidth: 'Fixed',
  title: '',
  style: {
    minHeight: '100vh',
  },
  menuItemRender: (menuItemProps, defaultDom) => {
    if (menuItemProps.path.indexOf('http') > -1) {
      return (
        // TODO: Maybe use react router dom link instead here for a more efficient navigation
        <a
          href={menuItemProps.path}
          target={menuItemProps.target || '_self'}
          rel={menuItemProps.target === '_blank' ? 'noopener noreferrer' : undefined}
        >
          {defaultDom}
        </a>
      );
    }
    return <a href={menuItemProps.path}>{defaultDom}</a>;
  },
};

export const publicDefaultSettings = {
  logo: '/logo_br.svg',
  navTheme: 'light',
  layout: 'topmenu',
  fixedHeader: true,
  contentWidth: 'wrap',
  title: '',
  style: {
    minHeight: '100vh',
  },
  menuItemRender: (menuItemProps, defaultDom) => {
    if (menuItemProps.path.indexOf('http') > -1) {
      return defaultDom;
    }
    return <a href={menuItemProps.path}>{defaultDom}</a>;
  },
};